import {
  ReactNode,
  createContext,
  useContext,
} from "react";

import { SystemTheme } from "use-system-theme";

import { useLoading } from "./hooks/useLoading";
import { useTheme } from "./hooks/useTheme";

import { CustomTheme } from "../@types/styled-components";
import { theme } from "../config/theme";
import { AuthUser } from "../models/User";
import { useUser } from "./hooks/useUser";
import { Channel } from "../models/Channel";
import { SavedSticker } from "../services/savedStickerServices";

export interface UseContext {
  theme: CustomTheme;
  themeMode: SystemTheme;
  changeTheme: () => void;
  loading: boolean;
  openLoading: () => void;
  closeLoading: () => void;
  user: AuthUser | null;
  login: ( user: AuthUser ) => void;
  logout: () => void;
  upsertSavedSticker: ( sticker: SavedSticker ) => void;
  removeSavedSticker: ( stickerId: string ) => void;
  changeChannelStatus: ( channel: Channel ) => void;
  setChannelConnections: ( connections: Array<Channel> ) => void;
};

export interface DefaultComponentProps {
  children: ReactNode;
};

export interface StateProviderProps extends DefaultComponentProps { };

export const store = createContext<UseContext>({
  theme: theme.light,
  themeMode: "light",
  changeTheme: () => {},
  loading: false,
  openLoading: () => { },
  closeLoading: () => { },
  user: null,
  login: ( _user: AuthUser ) => {},
  logout: () => {},
  upsertSavedSticker: ( sticker: SavedSticker ) => {},
  removeSavedSticker: ( stickerId: string ) => {},
  changeChannelStatus: ( channel: Channel ) => {},
  setChannelConnections: ( connections: Array<Channel> ) => {},
});

const { Provider } = store;

export const StateProvider = ({ children }: StateProviderProps ) => {
  const theme = useTheme();

  const loading = useLoading();

  const user = useUser();

  return (
    <Provider
      value={{
        ...theme,
        ...loading,
        ...user,
      }}
    >{children}</Provider>
  );
};

export const useStore = () => useContext( store );

